import { render, staticRenderFns } from "./world-recovery-day-mar3119.vue?vue&type=template&id=652e8bf1&scoped=true&"
import script from "./world-recovery-day-mar3119.vue?vue&type=script&lang=js&"
export * from "./world-recovery-day-mar3119.vue?vue&type=script&lang=js&"
import style0 from "./world-recovery-day-mar3119.vue?vue&type=style&index=0&id=652e8bf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e8bf1",
  null
  
)

export default component.exports